function sword(size: number = 32): string {
  return `<svg width="${size}" height="${size}" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <!-- Blade -->
    <path d="M16,3 L19,20 L16,22 L13,20 Z" fill="#C0C0C0" stroke="rgba(0,0,0,0.25)" stroke-width="0.8"/>
    <!-- Blade highlight -->
    <path d="M16,4 L17,18" stroke="rgba(255,255,255,0.4)" stroke-width="1" stroke-linecap="round"/>
    <!-- Crossguard -->
    <rect x="10" y="20" width="12" height="3" rx="1" fill="#8B6914" stroke="rgba(0,0,0,0.2)" stroke-width="0.8"/>
    <!-- Grip -->
    <rect x="14" y="23" width="4" height="5" fill="#4a3010" stroke="rgba(0,0,0,0.15)" stroke-width="0.5"/>
    <!-- Grip wrap -->
    <line x1="14" y1="25" x2="18" y2="25" stroke="#6B4F12" stroke-width="0.8"/>
    <line x1="14" y1="27" x2="18" y2="27" stroke="#6B4F12" stroke-width="0.8"/>
    <!-- Pommel -->
    <circle cx="16" cy="29" r="2" fill="#8B6914" stroke="rgba(0,0,0,0.2)" stroke-width="0.5"/>
  </svg>`;
}

function wand(size: number = 32): string {
  return `<svg width="${size}" height="${size}" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <!-- Staff -->
    <line x1="16" y1="10" x2="16" y2="29" stroke="#6B4F12" stroke-width="3" stroke-linecap="round"/>
    <!-- Star tip -->
    <polygon points="16,3 17.5,7 22,7.5 18.5,10 19.5,14 16,11.5 12.5,14 13.5,10 10,7.5 14.5,7" fill="#FFD700" stroke="#DAA520" stroke-width="0.5"/>
    <!-- Glow -->
    <circle cx="16" cy="8" r="5" fill="#FFD700" opacity="0.15"/>
    <!-- Grip detail -->
    <line x1="14.5" y1="22" x2="17.5" y2="22" stroke="#4a3010" stroke-width="0.8"/>
    <line x1="14.5" y1="24" x2="17.5" y2="24" stroke="#4a3010" stroke-width="0.8"/>
  </svg>`;
}

function bow(size: number = 32): string {
  return `<svg width="${size}" height="${size}" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <!-- Bow limb -->
    <path d="M12,4 Q4,16 12,28" fill="none" stroke="#8B4513" stroke-width="2.5" stroke-linecap="round"/>
    <!-- String -->
    <line x1="12" y1="4" x2="12" y2="28" stroke="#ddd" stroke-width="0.8"/>
    <!-- Grip -->
    <rect x="10" y="14" width="4" height="4" rx="1" fill="#6B4F12"/>
    <!-- Arrow -->
    <line x1="12" y1="16" x2="28" y2="16" stroke="#8B6914" stroke-width="1.5"/>
    <!-- Arrowhead -->
    <polygon points="28,16 24,13.5 24,18.5" fill="#C0C0C0" stroke="rgba(0,0,0,0.2)" stroke-width="0.5"/>
    <!-- Fletching -->
    <path d="M14,16 L12,14 M14,16 L12,18" stroke="#cc3333" stroke-width="0.8"/>
  </svg>`;
}

export const WEAPON_ICONS: Record<string, (size?: number) => string> = {
  training_sword: sword,
  apprentice_wand: wand,
  training_bow: bow,
};
